import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const CloseIcon = ({ className }) => (
  <svg viewBox="0 0 40 40" className={cn('icon', 'icon-close', className)}>
    <g stroke="#405FAF" strokeWidth="4">
      <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
    </g>
  </svg>
);
CloseIcon.propTypes = {
  className: PropTypes.string,
};
CloseIcon.defaultProps = {
  className: '',
};

export default CloseIcon;
